import { render, staticRenderFns } from "./VideoNotesPanelIcon.vue?vue&type=template&id=3980ff27"
import script from "./VideoNotesPanelIcon.vue?vue&type=script&lang=js"
export * from "./VideoNotesPanelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports